var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import * as React from 'react';
import styled from 'styled-components';
import { useLocation } from 'react-router-dom';
import qs from 'qs';
import { useSampleOrderColumns } from '../../../hooks/useColumns';
import { useFetchSampleOrders } from '../../../hooks/useSampleOrder';
import MaterialTable from '../../MaterialTable';
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 20px 30px;\n"], ["\n  margin: 20px 30px;\n"])));
var SampleOrdersContent = function (_a) {
    var roaster = _a.roaster;
    var location = useLocation();
    var fetchSampleOrders = useFetchSampleOrders({ roasterId: roaster.id }).fetchSampleOrders;
    var query = qs.parse(location.search.slice(1));
    var SampleOrderColumns = useSampleOrderColumns({
        role: 'admin',
        filters: query.filters,
        orderBy: query.orderBy,
        orderDirection: query.orderDirection,
    });
    var columns = React.useMemo(function () { return [
        SampleOrderColumns.offerListLink,
        SampleOrderColumns.producerName,
        SampleOrderColumns.storeName,
        SampleOrderColumns.personName,
        SampleOrderColumns.email,
        SampleOrderColumns.status,
        SampleOrderColumns.createdAt,
    ]; }, [SampleOrderColumns]);
    return (React.createElement(Wrapper, null,
        React.createElement(MaterialTable, { model: "sampleOrder", columns: columns, data: fetchSampleOrders, options: {
                initialPage: parseInt(query.page) || 0,
                pageSize: parseInt(query.pageSize) || 25,
                paging: true,
            }, detailPath: function (sampleOrder) { return "/admin/sample_orders/".concat(sampleOrder.id); } })));
};
export default SampleOrdersContent;
var templateObject_1;
